var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Redirect } from "@reach/router";
var GatedRoute = function (_a) {
    var path = _a.path, Component = _a.Component, isValid = _a.isValid, _b = _a.redirect, redirect = _b === void 0 ? "/" : _b, params = __rest(_a, ["path", "Component", "isValid", "redirect"]);
    if (isValid == undefined || isValid()) {
        return React.createElement(Component, { path: path, urlParams: params });
    }
    return React.createElement(Redirect, { to: redirect, noThrow: true });
};
export default GatedRoute;
//# sourceMappingURL=GatedRoute.js.map